import React, { lazy } from 'react';
const BONUSES = [{
  num: '01',
  title: 'Generador de Informes Pedagógicos',
  desc: 'Banco de frases por nivel y semáforo (verde/amarillo/rojo) para redactar 30 informes trimestrales en menos de 40 minutos.',
  value: '$4.990',
  image: 'https://cdn.magicpatterns.com/uploads/48siVbqVSAQ3pABPGWkyfv/95.png'
}, {
  num: '02',
  title: 'El Organizador Digital de Recursos',
  desc: 'Sistema para ordenar videos, juegos, canciones y sitios web por nivel. Encontrás cualquier recurso en 30 segundos.',
  value: '$4.990',
  image: 'https://cdn.magicpatterns.com/uploads/6MMqH2sbBCHomfDZwVURKB/96.png'
}, {
  num: '03',
  title: 'Planilla Maestra de Notas',
  desc: 'Google Sheets con fórmulas automáticas que calcula promedios y detecta alumnos en riesgo antes de que sea tarde.',
  value: '$6.990',
  image: 'https://cdn.magicpatterns.com/uploads/eXGhS3jPMEs8ABtjoxPHcA/97.png'
}, {
  num: '04',
  title: 'Pack de Seguimiento de Alumnos',
  desc: 'Fichas individuales, semáforo grupal semanal y radar de alerta temprana para detectar quién necesita ayuda de un vistazo.',
  value: '$5.990',
  image: 'https://cdn.magicpatterns.com/uploads/aEPgw7Wsd1eD1CKqv3oRab/98.png'
}, {
  num: '05',
  title: 'Plantillas de Recuperatorios',
  desc: 'Plantilla universal + banco de ejercicios por nivel + rúbrica de corrección. Armás un recuperatorio en 5 minutos.',
  value: '$5.990',
  image: 'https://cdn.magicpatterns.com/uploads/1SetXS4hWhLRz2pHAD3QrL/99.png'
}, {
  num: '06',
  title: 'Organizador Semanal Docente',
  desc: 'Planificador semanal, daily checklist y cierre de viernes para ordenar toda la semana en 20 minutos el domingo.',
  value: '$4.990',
  image: 'https://cdn.magicpatterns.com/uploads/g7iMDhVGjCEKzaBAhgk8eD/100.png'
}];
export function BonusSection() {
  return <section className="py-16 px-6 bg-white" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <div className="text-center mb-10" data-id="element-24">
          <p className="text-blue-600 font-semibold uppercase tracking-widest text-sm mb-2" data-id="element-25">
            Incluidos en todas las ofertas — sin costo extra
          </p>
          <h2 className="text-3xl font-extrabold text-gray-900" data-id="element-26">
            Más los 6 Regalos Estratégicos
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-27">
          {BONUSES.map(b => <div key={b.num} className="border border-gray-200 rounded-2xl p-5 relative hover:shadow-md transition" data-id="element-28">
              <div className="absolute -top-3 left-5 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-29">
                BONUS {b.num}
              </div>
              {b.image && <div className="mt-2 mb-3 flex justify-center" data-id="element-30">
                  <img src={b.image} alt={`Bonus ${b.num}: ${b.title}`} className="w-full max-w-[220px] h-auto rounded-xl" loading="lazy" decoding="async" data-id="element-31" />
                </div>}
              <div className="mt-2" data-id="element-32">
                <p className="font-bold text-gray-900 text-sm mb-1" data-id="element-33">
                  {b.title}
                </p>
                <p className="text-gray-500 text-xs mb-3" data-id="element-34">{b.desc}</p>
                <div className="flex items-center gap-2" data-id="element-35">
                  <span className="line-through text-gray-400 text-xs" data-id="element-36">
                    Valor {b.value}
                  </span>
                  <span className="bg-green-100 text-green-700 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-37">
                    → GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}